<ion-content>
  <ion-list>
    @if (canShare()) {
      <ion-item [button]="true" [detail]="false" lines="full" (click)="share()">Teilen</ion-item>
    }
    <ion-item [button]="true" [detail]="false" lines="full" (click)="download()">Herunterladen</ion-item>
    <ion-item [button]="true" [detail]="false" lines="none" (click)="delete()">Löschen</ion-item>
  </ion-list>
</ion-content>